const sortPaymentMethods = (methods) => {
  const preferredOrder = ['scheme', 'applepay', 'googlepay'];

  return methods?.paymentMethods?.sort((a, b) => {
    const aIndex = preferredOrder.indexOf(a.type);
    const bIndex = preferredOrder.indexOf(b.type);

    return (
      (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex)
    );
  });
};

export default sortPaymentMethods;
